import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { combineLatest, filter, map, shareReplay, startWith, tap } from 'rxjs';
import { WorkshopJobTemplate } from 'src/app/models/workshop-job-template';
import { WorkshopJobTemplateService } from 'src/app/shared/services/workshop-job-template.service';
import { MatOption } from '@angular/material/core';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-template-select',
    templateUrl: './template-select.component.html',
    providers: [WorkshopJobTemplateService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
      :host {
        width: 100%;
      }
    `
    ],
    standalone: true,
    imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, NgIf, MatOption, NgFor, AsyncPipe]
})
export class TemplateSelectComponent {
  templates$ = this.templateService.getAll().pipe(
    tap((source) => console.log({ source })),
    shareReplay(1)
  );

  searchControl = new FormControl<string>('');
  noTemplates$ = this.templates$.pipe(map((source) => source.length === 0));

  @Output() templateSelected = new EventEmitter<WorkshopJobTemplate>();

  filteredTemplates$ = combineLatest([
    this.templates$,
    this.searchControl.valueChanges.pipe(startWith(''))
  ]).pipe(
    filter(([templates, searchValue]) => typeof searchValue === 'string'),
    map(([templates, searchValue]) =>
      templates.filter((template) =>
        template.name.toLowerCase().includes(searchValue.toLowerCase())
      )
    )
  );

  emptyDisplayWith = (value: WorkshopJobTemplate) => value.name;

  constructor(private templateService: WorkshopJobTemplateService) {}
}
